export class TableColumnProfile {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "comment",
            "baseName": "comment",
            "type": "string",
            "format": ""
        },
        {
            "name": "nullRate",
            "baseName": "nullRate",
            "type": "number",
            "format": ""
        },
        {
            "name": "distinctCount",
            "baseName": "distinctCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "min",
            "baseName": "min",
            "type": "number",
            "format": ""
        },
        {
            "name": "max",
            "baseName": "max",
            "type": "number",
            "format": ""
        },
        {
            "name": "p50",
            "baseName": "p50",
            "type": "number",
            "format": ""
        },
        {
            "name": "p99",
            "baseName": "p99",
            "type": "number",
            "format": ""
        },
        {
            "name": "topValues",
            "baseName": "topValues",
            "type": "Array<TableColumnTopValue>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableColumnProfile.attributeTypeMap;
    }
    constructor() {
    }
}
